import {_utils} from "../../utils/_utils.js";
import {initCardsSlider} from "../../utils/cards-slider.js";

/**
 * Gallery slider — "Visual Story" (The Experience, TZ section 7):
 * → moves one photo forward, ← one back (see utils/cards-slider.js). Gap: 32px mobile, 20px desktop;
 * layout "Left" (portrait photos, Events "Moments") — 20px everywhere.
 */
export const gallerySlider = () => {
    return new Promise((resolve) => {
        _utils.initSection('.gallery-slider', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const slider = section.querySelector('.gallery-slider__slider');
    if (!slider) return;

    initCardsSlider(
        slider,
        section.querySelector('.gallery-slider__nav-btn--prev'),
        section.querySelector('.gallery-slider__nav-btn--next'),
        {
            spaceBetween: section.classList.contains('gallery-slider--left') ? 20 : 32,
            breakpoints: {
                1025: {spaceBetween: 20},
            },
        }
    );
};
